import { render, staticRenderFns } from "./freeEsports.vue?vue&type=template&id=80cb3b2e&"
import script from "./freeEsports.vue?vue&type=script&lang=js&"
export * from "./freeEsports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports